<template>
  <v-dialog v-model="internalShow" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ __("Alteração de Status") }}</v-card-title>

      <v-card-text>
        <div v-if="loading">
          <v-progress-linear indeterminate color="primary" />
          <p class="mt-2">{{ __("Processando mudança de status") }}...</p>
        </div>

        <div v-else-if="errors.length">
          <v-alert type="error" dense outlined>
            <p>
              <strong>
                {{
                  __(
                    "Não foi possível concluir a mudança de status devido às seguintes pendências:"
                  )
                }}
              </strong>
            </p>
            <ul>
              <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
            </ul>
          </v-alert>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="closeDialog">{{ __("Fechar") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { changeStatus } from "@/services/lead";
import i18n from "@/mixins/i18n";
import ToastsMixin from "@/mixins/ToastsMixin.vue";

export default {
  mixins: [i18n, ToastsMixin],
  props: {
    leadId: { type: Number, required: true },
  },
  data() {
    return {
      i18n_prefix: "leads",
      loading: false,
      errors: [],
      internalShow: false,
      statusIdInternal: null,
    };
  },
  methods: {
    async open(status) {
      this.statusIdInternal = status.id;
      this.internalShow = true;
      await this.executeStatusChange();
    },

    async executeStatusChange() {
      if (!this.statusIdInternal) return;

      this.loading = true;
      this.errors = [];

      try {
        const response = await changeStatus(this.leadId, this.statusIdInternal);

        this.toastSuccess(this.__("Status alterado com sucesso!", "leads"));

        this.$emit("updated", response);

        this.closeDialog();
      } catch (error) {
        const data = error.response?.data || {};
        this.errors =
          data.errors?.pendings && Array.isArray(data.errors.pendings)
            ? data.errors.pendings
            : [
                data.message ||
                  data.error ||
                  this.__("Erro desconhecido ao mudar o status.", "leads"),
              ];
      } finally {
        this.loading = false;
      }
    },

    closeDialog() {
      this.internalShow = false;
    },
  },
  watch: {
    internalShow(val) {
      if (!val) this.$emit("close");
    },
  },
};
</script>
